<template>
  <a-layout-content :class="!monitoring ? (isSPCL ? '' : 'p-all') : '' ">
    <a-spin :spinning="pageLoading">
      <a-row :gutter="16">
        <a-col :xs="24" :lg="16">
          <a-card>
            <a-row slot="title" type="flex" justify="space-between">
              <div>
                <span class="d-block">Manifest Realisasi Lembur</span>
                <small v-if="basedData.header">{{basedData.header.no_alokasi}}</small>
              </div>
              <div>
                <a-tag :color="'grey'" v-if="basedData.header && basedData.header.rekap_sts == '1'"><i>Telah direkap oleh HRD</i></a-tag>
              </div>
            </a-row>
              <a-popover slot="extra" trigger="focus" placement="bottomRight">
                <span slot="title">Pilih aksi</span>
                <ul class="list-wrapper bordered" slot="content">
                  <li v-if="basedData.status=='Revised'">
                    <a-button type="danger" class="w-full" icon="edit" @click="editTransaksi">
                      Ubah Data
                    </a-button>
                  </li>
                  <li>
                    <a-button
                      size="default"
                      class="w-full"
                      @click="handlePrint"
                      slot="extra"
                      icon="printer"
                      :loading="printLoading"
                    >{{ !isMobile ? 'Print Manifest' : '' }}</a-button>
                  </li>
                </ul>
              <a-button icon="more" id="buttonAksi">Aksi</a-button>
            </a-popover>

            <ul class="list-wrapper bordered">
              <li>
                <span class="list-title" for>Tanggal Pembuatan / Pembuat</span>
                <span
                  class="list-desc"
                  v-if="basedData.header">{{moment(basedData.header.create_dt).format(getDefaultDateFormat)}} / {{ basedData.header.tlc_create }}</span>
              </li>
              <li>
                <span class="list-title" for>Nomor SPL</span>
                <span class="list-desc" v-if="basedData.header">{{ basedData.header.no_spl }}</span>
              </li>
              <li>
                  <span class="list-title" for>Atas Perintah</span>
                  <span class="list-desc" v-if="basedData.header">{{ basedData.header.commander }}</span>
                </li>
              <li>
                <span class="list-title" for>Pelaksana</span>
                <span class="list-desc" v-if="basedData.header">{{basedData.header.pelaksana }}</span>
              </li>
              <li>
                <span class="list-title" for>Kode Proyek</span>
                <span class="list-desc" v-if="basedData.header">{{basedData.header.c_proyek }}</span>
              </li>
              <li>
                <span class="list-title" for>Uraian Tugas</span>
                <span class="list-desc" v-if="basedData.header">{{basedData.header.uraian }}</span>
              </li>
            </ul>
          </a-card>
          <a-card class="m-top d-flex flex-column nowrap" title="Detil Lembur">
            <a-list :grid="{ gutter: 16,lg: 1 }" :dataSource="basedData.detail" :pagination="pagination">
              <a-list-item slot="renderItem" slot-scope="item, index">
                <a-card hoverable class="d-flex flex-column nowrap">
                  <!-- <div slot="title" class="d-flex justify-between">
                    <span class="list-title">TLC</span>
                    <a-tag>{{item.c_proyek}}</a-tag>
                  </div> -->
                  <a-list-item-meta>
                    <ul slot="description" class="list-wrapper">
                      <table style="width:100%">
                        <tr >
                          <td>
                            <a-row :gutter="16">
                              <a-col :xs="24" :lg="isMobile ? 12: 4">
                                <div :class="isMobile ? 'head-dtl-lembur' : ''" style="width:100%">
                                <a-avatar
                                :size="isMobile ? 24 : 52"
                                :class="isMobile ? 'avatar-dtl-lembur' : ''"
                                >{{ index + 1 }}</a-avatar>
                                </div>
                              </a-col>
                              <a-col :xs="24" :lg="isMobile ? 12 : 20">
                                <a-row :gutter="16" :class="isMobile ? 'm-top' : ''">
                                  <a-col :xs="24" :lg="12">
                                    <li class="m-remove">
                                      <span class="list-title">Tanggal</span>
                                      <span class="list-desc">{{ item.date }}</span>
                                    </li>
                                  </a-col>
                                  <a-col :xs="24" :lg="12">
                                    <li class="m-remove">
                                      <span class="list-title">Estimasi Waktu</span>
                                      <span class="list-desc">{{ moment(item.start_time).format("HH:mm") }} s.d {{ moment(item.end_time).format("HH:mm") }}</span>
                                    </li>
                                  </a-col>
                                </a-row>
                                <a-row :gutter="16">
                                  <a-col :xs="24" :lg="12">
                                    <li class="m-remove">
                                      <span class="list-title">TLC Pelaksana</span>
                                      <span class="list-desc">{{ item.pelaksana }}</span>
                                    </li>
                                  </a-col>
                                  <a-col :xs="24" :lg="12">
                                    <li class="m-remove">
                                      <span class="list-title">Lokasi Lembur</span>
                                      <span class="list-desc">{{ item.lokasi }}</span>
                                    </li>
                                  </a-col>
                                </a-row>
                              </a-col>
                            </a-row>
                          </td>
                        </tr>
                      </table>
                    </ul>
                  </a-list-item-meta>
                </a-card>
              </a-list-item>
            </a-list>
          </a-card>
          <a-card class="m-top d-flex flex-column nowrap" title="Detil Realisasi Lembur">
            <a-form class="m-form" :form="formEditHRD">
            <a-list :grid="{ gutter: 16, lg: 1 }" :dataSource="basedData.realisasi" :pagination="pagination">
              <a-list-item slot="renderItem" slot-scope="item, index">
                <a-card hoverable class="d-flex flex-column nowrap">
                  <!-- <div slot="title" class="d-flex justify-between">
                  <span class="list-title">TLC</span>
                  <a-tag>{{item.c_proyek}}</a-tag>
                </div> -->
                  <a-list-item-meta>
                    <ul slot="description" class="list-wrapper">
                      <table style="width:100%">
                        <tr >
                          <td>
                            <a-row :gutter="16">
                              <a-col :xs="24" :lg="3">
                                <div :class="isMobile ? 'head-dtl-lembur' :''" style="width:100%">
                                <a-avatar
                                :size="isMobile? 24 : 52"
                                :class="isMobile ? 'avatar-dtl-lembur' : ''"
                                >{{ index + 1 }}</a-avatar>
                                </div>
                              </a-col>
                              <a-col :xs="24" :lg="12">
                                <a-row :gutter="8" :class="isMobile ? 'm-top' : ''">
                                  <a-col :xs="24" :lg="14">
                                    <li class="m-remove">
                                      <span class="list-title">Tanggal</span>
                                      <span class="list-desc">{{ item.start_time ? moment(item.start_time).format(getDefaultDateFormat) : '-' }}</span>
                                    </li>
                                    <li class="m-remove">
                                      <span class="list-title">Realisasi Waktu Sistem</span>
                                      <span class="list-desc">{{ moment(item.start_time).format("HH:mm") }} s.d {{ moment(item.end_time).format("HH:mm") }}</span>
                                    </li>
                                    <li class="m-remove">
                                      <span class="list-title">Realisasi Waktu Manual</span>
                                      <span class="list-desc">{{ moment(item.start_time_usr).format("HH:mm") }} s.d {{ moment(item.end_time_usr).format("HH:mm") }}</span>
                                    </li>
                                    <li class="m-remove">
                                      <span class="list-title">Realisasi Waktu HRD</span>
                                      <span class="list-desc" v-if="editingRealisasi && modalEditHRD.realisasi_spl_dtl_id == item.realisasi_spl_dtl_id">
                                        <a-form-item>
                                          <a-time-picker v-decorator="[
                                            'start_realisasi_hrd'+ item.realisasi_spl_dtl_id,
                                            {
                                              rules: [{ required: true, message: 'Realisasi Awal is required!' }], initialValue: modalEditHRD.start_realisasi_hrd,
                                            },
                                          ]" format="HH:mm" placeholder="Awal" class="w-full" />  
                                        </a-form-item>
                                        <a-form-item>
                                          <a-time-picker v-decorator="[
                                            'end_realisasi_hrd' + item.realisasi_spl_dtl_id,
                                            {
                                              rules: [{ required: true, message: 'Realisasi Akhir is required!' }], initialValue: modalEditHRD.end_realisasi_hrd,
                                            },
                                          ]" format="HH:mm" placeholder="Akhir" class="w-full m-top" />
                                        </a-form-item>
                                      </span>
                                      <span class="list-desc" v-else>
                                        {{ item.start_time_hrd ? moment(item.start_time_hrd).format("HH:mm") : "-" }} s.d {{ item.end_time_hrd ? moment(item.end_time_hrd).format("HH:mm") : "-" }}
                                      </span>
                                    </li>
                                  </a-col>
                                  <a-col :xs="24" :lg="10">
                                    <li class="m-remove">
                                      <span class="list-title">TLC Pelaksana</span>
                                      <span class="list-desc">{{ item.pelaksana }}</span>
                                    </li>
                                    <li class="m-remove">
                                      <span class="list-title">Durasi</span>
                                      <span class="list-desc">{{ realisasijam(item.start_time, item.end_time) }}</span>
                                    </li>
                                    <li class="m-remove">
                                      <span class="list-title">Durasi</span>
                                      <span class="list-desc">{{ realisasijam(item.start_time_usr, item.end_time_usr) }}</span>
                                    </li>
                                    <li class="m-remove">
                                      <span class="list-title">Durasi</span>
                                      <span class="list-desc">{{ item.start_time_hrd && item.end_time_hrd ? realisasijam(item.start_time_hrd, item.end_time_hrd) : "-" }}</span>
                                    </li>
                                    <li class="m-remove">
                                      <span class="list-title">Total Tarif</span>
                                      <span class="list-desc">{{ formatDecimal(item.nilai_tarip) }}</span>
                                    </li>
                                  </a-col>
                                </a-row>
                                <a-row>
                                  <a-col>
                                    <li class="m-remove">
                                      <span class="list-title">Catatan</span>
                                      <span class="list-desc">{{ item.catatan }}</span>
                                    </li>
                                  </a-col>
                                </a-row>
                              </a-col>
                              <a-col :xs="24" :lg="9">
                                <a-table
                                  :key="'log'+ index"
                                  :rowKey="(record, index) => {return index;}"
                                  :columns="columnslogHistory"
                                  :dataSource="item.log_absen"
                                  :pagination="false"
                                  :scroll="{ y: 100 }"
                                  size="small"
                                  bordered
                                  :class="isMobile ? 'm-top' : ''"
                                >
                                  <template slot="no" slot-scope="value, item, index">
                                    {{ (index + 1) }}
                                  </template>
                                </a-table>
                                  <a-button v-if="isHRD && basedData.jenis=='Approve'" 
                                  :loading="loadingSavetimeHrd && modalEditHRD.realisasi_spl_dtl_id == item.realisasi_spl_dtl_id" :type="item.start_time_hrd!=null ? 'primary' : 'danger'" 
                                  class="w-full m-top" @click="editRealisasi(item)">
                                  {{ editingRealisasi && modalEditHRD.realisasi_spl_dtl_id == item.realisasi_spl_dtl_id ? 'Simpan' : 'Edit Realisasi Waktu HRD' }}
                                  </a-button>
                              </a-col>
                            </a-row>
                          </td>
                        </tr>
                      </table>
                    </ul>
                  </a-list-item-meta>
                </a-card>
              </a-list-item>
            </a-list>
            </a-form>
          </a-card>
        </a-col>
        <a-col :xs="24" :lg="8" :class="isMobile ? 'm-top' : ''">
          <a-collapse activeKey="1" forceRender >
            <a-collapse-panel key="1">
              <div class="d-flex justify-between align-middle" slot="header">
                <span class="margin-remove">Status</span>
                <div>
                  <H-Status :status="basedData.status" />
                  <a-tooltip placement="topRight">
                    <template #title>
                      <span>History</span>
                    </template>
                    <a-button  @click="handleHistory" type="default" size="small" >
                      <a-icon type="history" />
                    </a-button>
                  </a-tooltip>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="grey">
                  <div class="m-timeline-title">Pembuat - {{basedData.header ? basedData.header.tlc_create : null}}</div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">{{basedData.header ? basedData.header.create_dt: null}}</h4>
<!--                    <span class="m-text-small">{{data.invoice.keperluan ? data.invoice.keperluan : 'Tidak Ada Keperluan'}}</span>-->
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">CREATED</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  :color="workflow.status === 'On Process' || workflow.status === 'Delivered' ? 'green' : workflow.status === 'Waiting' ? 'grey' : workflow.status === 'Rejected' || workflow.status === 'Revised' ? 'red' : 'grey'"
                  v-for="workflow in basedData.status_app"
                  :key="workflow.step_no"
                >
                  <div class="m-timeline-title">{{workflow.actor}} - {{workflow.tlc}}</div>
                  <div class="m-timeline-body">
                    <h4
                      class="margin-remove"
                      v-if="workflow.tanggal_aksi !== null"
                    >{{workflow.tanggal_aksi}}</h4>
                    <span class="m-text-small" v-if="workflow.remark">{{workflow.remark}}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <H-Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse :class="'margin-top'" activeKey="1" forceRender>
            <a-collapse-panel key="1">
              <div
                class="d-flex justify-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Dokumen Terkait</h4>
              </div>
              <ul class="list-wrapper bordered">
                <li v-for="(dbt, index) in basedData.dokumen_terkait" :key="index">
                  <div
                    slot="title"
                    class="m-display-flex space-between align-middle nowrap"
                  >
                    <h4 class="margin-remove m-text-dots">
                      SPL
                    </h4>
                    <a class="margin-remove m-text-dots" @click="goToSPL(dbt.spl_id)">
                      {{ dbt.spl_no }}
                    </a>
                    <div><small><b>Pelaksana :</b> {{ dbt.pelaksana }}</small></div>
                    <small><b>Perintah : </b> {{ dbt.commander }}</small>
                  </div>
                </li>
              </ul>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :xs="24" :lg="16">
          <a-card class="m-top" v-if="basedData.jenis !== 'Manifest'">
            <div slot="title">Tindakan Manifest</div>

            <a-form :form="form">
              <a-form-item class="m-remove" label="Catatan">
                <a-textarea
                  placeholder="Tulis catatan disini ... "
                  :rows="4"
                  v-decorator="['catatan']"
                />
              </a-form-item>
              <a-form-item label="Aksi">
                <a-select showSearch v-decorator="['aksi', { rules: [{ required: true }] }]">
                  <a-select-option v-for="item in basedData.aksi" :key="item.aksi">{{ item.aksi }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button @click="handleAction" block type="primary" html-type="submit">Simpan</a-button>
              </a-form-item>
            </a-form>
          </a-card>
        </a-col>
      </a-row>
    </a-spin>


    <a-modal v-model="history" @ok="handleHistory" :footer="null">
      <span slot="title">
        <a-icon type="history" />&nbsp;History Status
      </span>

      <ul class="list-wrapper bordered">
        <li v-for="history in basedData.notifikasi" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="d-flex justify-between">
              <h3 class="m-remove list-title">{{history.as_from}} | {{history.tlc_from}}</h3>
              <H-Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{history.tgl_notif}}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="d-flex justify-between">
              <h3
                class="m-remove list-title"
                v-if="(history.aksi === '4' && history.deskripsi === 'Edited') || history.deskripsi === 'Revised'"
              >{{history.as_from}} | {{history.tlc_from}}</h3>
              <h3 class="m-remove list-title" v-else>{{history.as_to}} | {{history.tlc_to}}</h3>
              <H-Status :status="history.deskripsi" />
            </div>
            <span class="list-desc">{{history.tgl_notif}}</span>
          </div>
        </li>
      </ul>
    </a-modal>
  </a-layout-content>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import Status from "@/components/Status.vue";
import _ from "lodash";

export default {
  props: ["id"],
  components: {
      "H-Status": Status
  },
  name: "ManifestRealisasiLembur",
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formEditHRD  = this.$form.createForm(this);
  },
  data() {
    return {
      basedData: {},
      pagination: {
        onChange: page => {
          console.log(page);
        },
        pageSize: 5,
        size: "small"
      },
      monitoring: false,
      pageLoading: false,
      printLoading: false,
      history: false,
      activeKey: ['1'],
      columnslogHistory: [
        {
          title: "#",
          scopedSlots: { customRender: "no" },
          align: "right",
          width: "35px"
        },
        {
          title: "Log. Absensi",
          dataIndex: "timestamp",
          align: "center",
        },
      ],
      editingRealisasi: false,
      modalEditHRD: {
        realisasi_spl_dtl_id: ""
      },
      loadingSavetimeHrd: false,
    };
  },
  watch: {
    id() {
      if (this.id) {
        this.fetching();
      }
    }
  },
  created() {
    this.fetching();
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat", "getStandartFormatDate"]),
    isHRD() {
      let result = false
      let hrd = _.filter(this.getAuth.divisi, (el) => el.toLowerCase() == "hrd")
      if (hrd.length > 0)
        result = true
      return result
    },
    isSPCL() {
      return this.$route.meta.isSPCL ? true : false
    },
  },

  methods: {
    moment,
    async fetching() {
      await axios({
        method: "get",
        url: this.$serviceUrl + "Realisasi_spl",
        params: {
          id_manifest: this.id
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          if (response.data) {
            this.basedData = {
              header: response.data.header[0],
              detail: response.data.jadwal_pekerjaan,
              realisasi: response.data.detail_realisasi,
              notifikasi: response.data.notifikasi,
              status_app :   response.data.status_app,
              status: response.data.status,
              jenis: response.data.jenis,
              id_manifest: response.data.id_manifest,
              aksi: response.data.aksi,
              dokumen_terkait: response.data.dokumen_terkait
            };
          }
        })
        .catch(err => {
          console.log(err.response);
        });
    },
    handlePrint() {
      let parameters = {
        realisasi_id: this.id,
        rekap_sts: "0",
        tlc: this.getAuth.username
      };

      // if (this.isHRD && this.basedData.status=='Approved' && this.basedData.header.rekap_sts!="1") {
      //   let that = this;
      //   this.$confirm({
      //     title: "Apakah Transaksi ini dimasukkan ke rekapitulasi?",
      //     content: "",
      //     okText: "Yes",
      //     cancelText: "No",
      //     onOk() {
      //       parameters.rekap_sts = "1";
      //       that.printProcess(parameters)
      //     },
      //     onCancel() {
      //       that.printProcess(parameters)
      //     },
      //   });
      // } else {
        this.printProcess(parameters)
      // }
    },
    printProcess(parameters) {
      if (parameters.rekap_sts == "0" && this.isHRD) {
        this.pageLoading = true;
      } else {
        this.printLoading = true;
      }
      axios({
        method: "get",
        url: this.$serviceUrl + "Realisasi_spl/cetak",
        responseType: "blob",
        params: parameters,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          if (parameters.rekap_sts == "0" && this.isHRD) {
            this.pageLoading = false;
          } else {
            this.printLoading = false;
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.$notification.error({
              message: "Error",
              description: "Gangguan System, error code 404!"
            });
          }
          if (parameters.rekap_sts == "0" && this.isHRD) {
            this.pageLoading = false;
          } else {
            this.printLoading = false;
          }
          this.$router.go();
        });
    },
    handleHistory(event) {
        this.history = true;
        event.stopPropagation();
    },
    handleAction() {
      this.confirmMessage("confirm-save");
    },
    handleActionProcess() {
        this.form.validateFields((err, values) => {
            if (err) {
                this.$notification.error({
                    message: "Error",
                    description: "Pilih Aksi Terlebih Dahulu!"
                });
                return;
          }

          let hrddata = _.filter(this.basedData.realisasi, (el) => el.start_time_hrd == null || el.end_time_hrd == null)
          if (values.aksi=="Approved" && hrddata.length > 0) {
            this.displayMessageValue("error-basic", "Masih ada Realisasi Waktu HRD yang belum terisi!");
            return
          }

            axios({
                method: "post",
                url: this.$serviceUrl + "Realisasi_spl/approval",
                data: {
                    id_manifest: this.id,
                    tlc: this.getAuth.username,
                    status: values.aksi,
                    remark: values.catatan ? values.catatan : ""
                },
                auth: {
                    username: this.getAuth.username,
                    password: this.getAuth.password
                },
                headers: {
                    "Content-Type": "application/json",
                    "X-API-KEY": this.getAuth.apikey
                }
            })
                .then(() => {
                    this.$notification.success({
                        message: "Sukses",
                        description: "Data telah berhasil diproses!"
                    });
                    Event.$emit("refreshNotification", true);
                    this.$router.go();
                })
              .catch((err) => {
                err = Object.assign({}, err.response)
                  if (err.data.message) {
                    this.displayMessageValue("error-basic", err.data.message);
                  } else {
                    let response = Object.assign({}, err.response);
                    this.displayMessageValue("error-other", response);
                  }
                });
        });
    },
    editTransaksi() {
      this.$router.push({
        name: "editRealisasiSPL",
        params: { id: this.id},
      });
    },
    realisasijam(start, end) {
      let result = ""
      start = moment(start)
      end = moment(end)
      let durasi = moment.duration(end.diff(start));
      result = durasi.hours() + " jam " + durasi.minutes() + " menit"
      return result
    },
    editRealisasi(val) {
      if (this.modalEditHRD.realisasi_spl_dtl_id=="") {
        this.modalEditHRD.realisasi_spl_dtl_id = val.realisasi_spl_dtl_id
        this.modalEditHRD.start_realisasi_hrd = val.start_time_hrd
        this.modalEditHRD.end_realisasi_hrd = val.end_time_hrd
        this.editingRealisasi = true
      } else {
        let start = this.formEditHRD.getFieldValue('start_realisasi_hrd' + val.realisasi_spl_dtl_id);
        let end = this.formEditHRD.getFieldValue('end_realisasi_hrd' + val.realisasi_spl_dtl_id);
        if (start && end) {
          start = moment(val.spl_dt + " " + moment(start).format("HH:mm:ss")).format("YYYY-MM-DD HH:mm:ss")
          end = moment(val.spl_dt + " " + moment(end).format("HH:mm:ss")).format("YYYY-MM-DD HH:mm:ss")

          let post = new FormData();
          post.append("start_date", start);
          post.append("end_date", end);
          post.append("realisasi_spl_dtl_id", val.realisasi_spl_dtl_id);

          this.loadingSavetimeHrd = true
          axios({
            method: "post",
            url: this.$serviceUrl + "Realisasi_spl/verifikasi_hrd",
            processData: false,
            data: post,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey
            }
          })
            .then((response) => {
              let index = _.findIndex(this.basedData.realisasi, (el) => el.realisasi_spl_dtl_id == val.realisasi_spl_dtl_id)
              this.basedData.realisasi[index].start_time_hrd = start
              this.basedData.realisasi[index].end_time_hrd = end
              this.basedData.realisasi[index].nilai_tarip = response.data.detail.nilai_tarip

              this.modalEditHRD.realisasi_spl_dtl_id = ""
              this.modalEditHRD.start_realisasi_hrd = ""
              this.modalEditHRD.end_realisasi_hrd = ""
              this.editingRealisasi = false
              this.loadingSavetimeHrd = false
              this.displayMessage("success-save");
            })
            .catch((err) => {
              this.loadingSavetimeHrd = false
              console.log(err)
              if (err.message) {
                this.displayMessageValue("error", err.message);
              } else {
                let responses = Object.assign({}, err);
                this.displayMessageValue("error", responses);
              }
            });
        } else {
          this.displayMessageValue("error-basic", "Waktu Awal dan Akhir harus diisi!");
        }
      }
    },
    onClose() {
      
    },
    formatDecimal(val) {
      return Number(val).toFixed(4)
    },

    goToSPL(id) {
      let result = "manifestSpl"
      if (this.kodeMenu == "9") {
        result = "manifestSplDir"
      } else if (this.kodeMenu == "4") {
        result = "manifestSplHrd"
      } else if (this.kodeMenu == "12") {
        result = "manifestSplAL"
      }
      this.$router.push({
        name: result,
        params: { id: id },
      });
    }
  },
  mounted() {
    Event.$on("confirmMessageReturn", this.handleActionProcess);
    if (
      this.$router.currentRoute.name == "hrd.mon.manifest.alokasi" ||
      this.$router.currentRoute.name == "al.mon.manifest.alokasi" ||
      this.$router.currentRoute.name == "dir.mon.manifest.alokasi"
    ) {
      this.monitoring = true;
    } else {
      this.monitoring = false;
    }
  }
};
</script>

<style lang="less">
.head-dtl-lembur{
  background-color: @primary-color;
  padding: 5px;
}
.avatar-dtl-lembur{
  background: rgba(0, 0, 0, 0.3);
}
</style>
